import { modalAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
const {
  definePartsStyle,
  defineMultiStyleConfig
} = createMultiStyleConfigHelpers(parts.keys);
const contentCreation = definePartsStyle({
  header: {
    paddingTop: 8,
    paddingX: 8,
    borderBottom: '1px solid',
    borderBottomColor: 'GREYSCALE.SATELLITE',
    paddingBottom: 3
  },
  closeButton: {
    top: 6,
    right: 6
  },
  body: {
    py: 3,
    px: 8
  },
  footer: {
    paddingTop: 3,
    px: 8,
    paddingBottom: 8
  }
});
export const modalTheme = defineMultiStyleConfig({
  variants: {
    contentCreation
  }
});